module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "كلمة-المؤلف"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كلمة المؤلِّف")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الحمد لله ربّ العالمين والصَّلاة والسَّلام على سيّدنا محمد وعلى آله وأصحابه أجمعين وبعد")]), _vm._v("…")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بفضلٍ منَ الله وتوفيقه وعَونه أوّلًا وآخِرًا، أذن الله تعالى جلّ جلاله أن يتمّ جَمع هذه الأعمال الفريدة والمرتبطة بالعلوم الرياضيَّة وعلوم الوقاية الإشعاعية.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قال الله تعالى في كتابه العظيم: بسم الله الرحمن الرحيم، \"وَمَا أُوْتِيتُمْ مِنَ الْعِلْمِ إِلَّا قَلِيلًا\"، (صدق الله العظيم).")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وهذه الأعمال ليسَت كباقي الدراسات، فقدِ اجتهدَ علماء الرياضيَّات منذ القِدم لمعرفة سلوك منظومة الأعداد الأوَّلية، والَّتي تُعرَفْ بأن أيَّ عدد مِن منظومتها لا يقبَل القسمة إلا على نفسه وعلى العدد واحد، ورغمَ التطوُّر والتقدُّم التقني المُذهل في مختلف المجالات فقد عجزَت كافَّة الاجتهادات عنِ الوصول لبيانات تكون نقطة البداية، تربط هذه الأعداد بعضها ببعض، ويُعتقد أنَّه إذا اكتشف سرُّ منظومة هذه الأعداد، فسيكون بتحقيق ذلك، حلول لكثيرٍ منَ المشكلات الرياضيَّة والتطبيقيَّة الَّتي تعترض جمهور العلماء، وخاصةً في مجالات المخاطبة والاتصالات وغيرها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تكوَّنت فكرة العمل على مسألة منظومة الأعداد الأوَّلية مِن خلال نبأ في الصُّحف يُفيد بأنَّ علماء الرياضيات والفيزياء طرحوا في مؤتمرهم الأخير بنهاية الألفية (2000) السَّابقة هذه المسألة كإحدى المشكلات المستعصية عن الحلّ، ودعيت هذه المسألة مع ستّ مسائل أخرى بمشكلات الألفية، ورصدوا جوائز مالية تشجيعية لحلِّها رغم أنَّهم على يقينٍ تامّ بعدَم وجود حلولٍ لها كما يعتقدون.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نأمل منَ الله تعالى أن تستثمِرَ نقطة البداية المستنتجة مِن هذه الدراسة مع المكتشفات الأخرى بمجال الوقاية الإشعاعية والمتضمّنة في هذا الكتيّب في سبيل خدمة العلم ورفع شأنِه لإسعاد البشرية الَّتي كرَّمَها الله تعالى؛ حيث قال في القرآن الكريم: \"وَلَقَدْ كَرَّمْنَا بَنِي آدَمَ\". (صدق الله العظيم).")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("واللهُ وليُّ التَّوفيق")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("والله مِن وراء القَصد")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المؤلِّف")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("محمد محروقة")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c0513d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch006.vue
// module id = 78
// module chunks = 0